function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_281",
  "data-name": "Path 281",
  d: "M1983.018-275.071c-7.591,0-12.5-5.885-17.249-11.577-5.1-6.114-9.917-11.888-17.949-11.888-7.469,0-11.82,4.973-16.858,10.731-.657.751-1.337,1.528-2.02,2.287a2.933,2.933,0,0,1-4.143.217,2.933,2.933,0,0,1-.217-4.142c.656-.728,1.321-1.489,1.966-2.225,5.222-5.969,11.142-12.734,21.273-12.734,10.778,0,16.981,7.436,22.454,14,4.238,5.081,7.9,9.468,12.744,9.468,7.468,0,11.82-4.973,16.858-10.731,1.287-1.471,2.618-2.993,4.014-4.424a2.934,2.934,0,0,1,4.148-.052,2.933,2.933,0,0,1,.052,4.148c-1.285,1.318-2.506,2.714-3.8,4.192C1999.068-281.836,1993.148-275.071,1983.018-275.071Z",
  transform: "translate(-1923.829 310.596)",
  fill: "#bcbcbc"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_282",
  "data-name": "Path 282",
  d: "M2001.5-244.35a1.466,1.466,0,0,1-1.467-1.467V-265.8a1.467,1.467,0,0,1,1.467-1.467,1.467,1.467,0,0,1,1.467,1.467v19.98A1.467,1.467,0,0,1,2001.5-244.35Z",
  transform: "translate(-1977.683 284.35)",
  fill: "#bcbcbc"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_283",
  "data-name": "Path 283",
  d: "M1970.4-237.921a1.467,1.467,0,0,1-1.467-1.467v-10.856a1.467,1.467,0,0,1,1.467-1.467,1.467,1.467,0,0,1,1.467,1.467v10.856A1.467,1.467,0,0,1,1970.4-237.921Z",
  transform: "translate(-1955.707 273.36)",
  fill: "#bcbcbc"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_284",
  "data-name": "Path 284",
  d: "M2032.6-237.921a1.467,1.467,0,0,1-1.467-1.467v-10.856a1.467,1.467,0,0,1,1.467-1.467,1.466,1.466,0,0,1,1.467,1.467v10.856A1.466,1.466,0,0,1,2032.6-237.921Z",
  transform: "translate(-1999.66 273.36)",
  fill: "#bcbcbc"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_285",
  "data-name": "Path 285",
  d: "M2124.825-302.606a1.467,1.467,0,0,1-1.466-1.467v-19.98a1.467,1.467,0,0,1,1.466-1.467,1.467,1.467,0,0,1,1.467,1.467v19.98A1.467,1.467,0,0,1,2124.825-302.606Z",
  transform: "translate(-2064.834 325.519)",
  fill: "#bcbcbc"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_286",
  "data-name": "Path 286",
  d: "M2093.729-296.177a1.467,1.467,0,0,1-1.467-1.467V-308.5a1.467,1.467,0,0,1,1.467-1.467,1.467,1.467,0,0,1,1.466,1.467v10.856A1.467,1.467,0,0,1,2093.729-296.177Z",
  transform: "translate(-2042.858 314.529)",
  fill: "#bcbcbc"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_287",
  "data-name": "Path 287",
  d: "M2155.924-296.177a1.467,1.467,0,0,1-1.467-1.467V-308.5a1.467,1.467,0,0,1,1.467-1.467,1.466,1.466,0,0,1,1.466,1.467v10.856A1.466,1.466,0,0,1,2155.924-296.177Z",
  transform: "translate(-2086.811 314.529)",
  fill: "#bcbcbc"
});

var SvgHelixIcon = function SvgHelixIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "icon-footer",
    width: 85.095,
    height: 40,
    viewBox: "0 0 85.095 40",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHelixIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/helix-icon.879c050a.svg";
export { ForwardRef as ReactComponent };